import { useEffect, useMemo, useState, useRef } from 'react';
import play_icon from '../../assets/images/play_icon.svg';
import { IOSSwitch } from '../../components/IOSSwitch';
import lightbulb_icon from '../../assets/images/lightbulb_icon.svg';
import { Box, Button, Card, CardContent, Checkbox, Popover, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import filter_icon from '../../assets/images/filter_icon.svg';
import { getFutureDate } from '../../utils/getFutureDate';
import { FiltersContainerOutliers } from './FiltersContainerOutliers';
import { MobileOutliersFilters } from './MobileOutliersFilters';
import { getOutlierResults } from '../../utils/api/getOutlierResults';
import { getGamesData, getLinksData } from '../../utils/api/evScreen';
import axios from 'axios';
import { UpgradeModal } from '../../components/UpgradeModal/UpgradeModal';
import wwlogo_gif from '../../assets/ww_loading2.gif';
import { getRelatedOdds } from '../../utils/api/getRelatedOdds';
import { LogoGenerator } from '../../components/LogoGenerator';
import { addPlusSign, removeObjectWithProperty } from '../evscreen/EvScreenTable/evScreenTable';
import { BetLinkButton } from '../../components/BetLinkButton';
import { EVPercent } from '../../components/EVPercent';
import { removeBetPlaced, setBetPlaced } from '../../utils/api/setBetPlaced';
import { americanToDecimal, RelatedOddsDropdown } from '../evscreen/EvScreenTable/RelatedOddsDropdown';
import { convertDecimalToAmerican } from '../evscreen/utils';
import SportsbookLogos from './SportsbooksLogos';
import { DesktopOutliersButton } from './DesktopOutliersButton';
import { MobileOutliersButton } from './MobileOutliersButton';
import './OutlierPlays.css';

export const OutlierPlays = (props) => {
	const { email, accessToken, bankroll, isMobile } = props;

	const [outlierResults, setOutlierResults] = useState();

	const [refreshCounter, setRefreshCounter] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [isScannable, setIsScannable] = useState(true);
	const [isAutoRefresh, setIsAutoRefresh] = useState(false);
	const [isLive, setIsLive] = useState(false);
	const [isPlacedUnplacedOpen, setIsPlacedUnplacedOpen] = useState(false);
	const [isPlacedAnchorEl, setIsPlacedAnchorEl] = useState();
	const [allBetsOpen, setAllBetsOpen] = useState('all');
	const [isFiltersOpen, setIsFiltersOpen] = useState(false);
	const user = JSON.parse(window.localStorage.getItem('userdb'));
	const date = getFutureDate(user?.query_outliers?.dateDifference || 7);
	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
	const [selectedRow, setSelectedRow] = useState();
	const [selectedRowIndex, setSelectedRowIndex] = useState();
	const [selectedSport, setSelectedSport] = useState();

	const [sortColumn, setSortColumn] = useState('over_discrepancy_pct');
	const [sortDirection, setSortDirection] = useState('desc');
	const [placedBets, setPlacedBets] = useState([]);
	const [relatedOdds, setRelatedOdds] = useState();
	const [amountPopoverAnchor, setAmountPopoverAnchor] = useState(null);
	const [amountPopoverRowId, setAmountPopoverRowId] = useState(null);
	const hoverTimeoutRef = useRef(null);
	const popoverRef = useRef(null);
	const [queries, setQueries] = useState(user?.query_outliers || []);
	const [userState, setUserState] = useState(user);

	const [filters, setFilters] = useState(
		user?.query_outliers?.find((q) => q?.[0]?.name === user.selected_query_outliers) ||
			(user?.query_outliers?.[0]
				? user?.query_outliers?.[0]
				: [
						{
							sports: user?.query_outliers?.[0].sports ? user?.query_outliers?.[0].sports : [],
							leagues: user?.query_outliers?.[0].leagues ? user?.query_outliers?.[0].leagues : [],
							sportsbooks: user?.query_outliers?.[0].sportsbooks ? user?.query_outliers?.[0].sportsbooks : [],
							sharpBooks: user?.query_outliers?.[0].sharpBooks
								? user?.query_outliers?.[0].sharpBooks
								: [
										// { label: 'WagerWiz Mains', value: 'WagerWiz Mains' },
										// { label: 'WagerWiz Props', value: 'WagerWiz Props' },
								  ],
							markets: user?.query_outliers?.[0].markets ? user?.query_outliers?.[0].markets : [],
							marketTypes: user?.query_outliers?.[0].marketTypes ? user?.query_outliers?.[0].marketTypes : [],
							minMaxEv: user?.query_outliers?.[0].minMaxEv ? user?.query_outliers?.[0].minMaxEv : [null, null],
							minMaxOdds: user?.query_outliers?.[0].minMaxOdds ? user?.query_outliers?.[0].minMaxOdds : [null, null],
							date: date ? date : new Date(),
							marketDepth: user?.query_outliers?.[0].marketDepth ? user?.query_outliers?.[0].marketDepth : 3,
							hide_alternates: user?.query_outliers?.[0].hide_alternates ? user?.query_outliers?.[0].hide_alternates : false,
						},
				  ])
	);

	const userdb = JSON.parse(window.localStorage.getItem('userdb'));

	const isFree = userdb?.stripe_subscription === null || !userdb?.stripe_subscription || userdb?.stripe_status === 'deleted' || userdb?.stripe_status === 'past_due';
	const isApprentice = userdb?.stripe_plan?.nickname?.includes('Apprentice') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due';

	useEffect(() => {
		const getOutliers = async () => {
			try {
				const res = await getOutlierResults(email, filters, isLive, accessToken);
				const gameIds = [];
				const outcomeIdsOver = [];
				const outcomeIdsUnder = [];
				const sports = [];

				for (const row of res) {
					const game_id = row.outcome_id_normalized.split(':')[0];
					if (!gameIds.some((gameId) => gameId === game_id)) {
						gameIds.push(game_id);
					}
					if (!sports.includes(row.sport)) {
						sports.push(row.sport);
					}
					outcomeIdsOver.push(row.outcome_id_normalized);
					outcomeIdsUnder.push(row.outcome_id_normalized);
				}
				const gamesData = await getGamesData(gameIds, accessToken);
				const linksDataOver = await getLinksData(outcomeIdsOver, sports, false);
				// const linksDataUnder = await getLinksData(outcomeIdsUnder, sports);

				for (const row of res) {
					const game = gamesData.games.find((g) => g.game_id === row.outcome_id_normalized.split(':')[0]);
					const linkOver = linksDataOver[row.outcome_id_normalized] || null;
					// const linkUnder = linksDataUnder[row.outcome_id_normalized] || null;

					row.game = game;
					let link_over;
					let link_under;
					// Handle new format: { ios, android, desktop } or old format: { deep_link_over: { desktop } }
					const desktopLink = linkOver?.desktop || linkOver?.deep_link_over?.desktop;
					if (desktopLink?.includes('betmgm')) {
						link_over = desktopLink?.replace(/<STATE>./g, 'on.').replace(/.com/g, '.ca');
					} else {
						link_over = desktopLink?.replace(/<STATE>./g, '');
					}

					const desktopLinkUnder = linkOver?.desktop || linkOver?.deep_link_under?.desktop;
					if (desktopLinkUnder?.includes('betmgm')) {
						link_under = desktopLinkUnder?.replace(/<STATE>./g, 'on.').replace(/.com/g, '.ca');
					} else {
						link_under = desktopLinkUnder?.replace(/<STATE>./g, '');
					}
					row.linkOver = link_over;
					row.linkUnder = link_under;
				}
				setOutlierResults(res);
				setIsLoading(false);
			} catch (e) {
				console.log('e: ', e);
				setIsLoading(false);
			}
		};
		if (!isFree && !isApprentice) {
			setIsLoading(true);
			getOutliers();

			if (isAutoRefresh) {
				let intervalId;

				if (isAutoRefresh) {
					intervalId = setInterval(async () => {
						// console.log('Autorefresh', new Date());
						await getOutliers();
					}, 10000);
				}

				return () => {
					if (intervalId) {
						clearInterval(intervalId);
					}
				};
			}
		} else {
			setIsLoading(false);
			setIsUpgradeModalOpen(true);
		}
	}, [refreshCounter, isLive, isAutoRefresh]);

	useEffect(() => {
		const getPlacedBets = async () => {
			try {
				const bets = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_placed_bets?email=${user.email}&arbitrage=true`, {
					headers: {
						Authorization: `Bearer ${accessToken}`,
					},
				});
				// console.log('bets: ', bets.data);
				setPlacedBets(bets.data?.placed_bets || []);
			} catch (error) {
				console.error('Error fetching placed bets:', error);
				setPlacedBets([]);
			}
		};
		getPlacedBets();
	}, []);

	// Click outside to close popover
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (amountPopoverAnchor && popoverRef.current) {
				// Check if click is outside the popover and not on the checkbox/trigger area
				const isInsidePopover = popoverRef.current.contains(event.target);
				const isCheckboxArea = event.target.closest('[data-popover-trigger]');
				
				if (!isInsidePopover && !isCheckboxArea) {
					if (hoverTimeoutRef.current) {
						clearTimeout(hoverTimeoutRef.current);
					}
					setAmountPopoverAnchor(null);
					setAmountPopoverRowId(null);
				}
			}
		};

		if (amountPopoverAnchor) {
			// Use a small delay to avoid closing immediately when opening
			const timeoutId = setTimeout(() => {
				document.addEventListener('mousedown', handleClickOutside);
			}, 100);

			return () => {
				clearTimeout(timeoutId);
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}
	}, [amountPopoverAnchor]);

	const visibleRows = useMemo(() => {
		let rows = [];
		rows = outlierResults?.sort((a, b) => {
			let valA, valB;

			if (sortColumn === 'max_discrepancy_pct') {
				valA = a.max_discrepancy_pct ?? 0;
				valB = b.max_discrepancy_pct ?? 0;
			} else if (sortColumn === 'time') {
				valA = new Date(a.game?.start_date).getTime();
				valB = new Date(b.game?.start_date).getTime();
			}

			return sortDirection === 'asc' ? valA - valB : valB - valA;
		});

		if (allBetsOpen === 'placed') {
			rows = rows.filter((row) => placedBets.some((placedbet) => placedbet.id === row.outcome_id_normalized));
		} else if (allBetsOpen === 'unplaced') {
			rows = rows.filter((row) => !placedBets.some((placedbet) => placedbet.id === row.over_outcome_id_normalized));
		}

		return rows;
	}, [outlierResults, allBetsOpen, placedBets, selectedRow, sortDirection, sortColumn]);

	return (
		<div style={{ backgroundColor: '#141416', height: '100%' }}>
			<div className="px-4 md:px-4 xl:px-6 pt-6 mb-6">
				<div className="w-full max-w-[95vw] mx-auto">
					<h2 style={{ textAlign: isMobile ? 'center' : 'left' }} className="text-3xl ev-scanner-title">
						Outlier Plays
					</h2>
				</div>
			</div>
			{!isMobile && (
				<div className="px-4 md:px-4 xl:px-6">
					<DesktopOutliersButton
						setIsLive={setIsLive}
						isPlacedUnplacedOpen={isPlacedUnplacedOpen}
						allBetsOpen={allBetsOpen}
						isPlacedAnchorEl={isPlacedAnchorEl}
						setAllBetsOpen={setAllBetsOpen}
						isFiltersOpen={isFiltersOpen}
						isLive={isLive}
						setIsPlacedUnplacedOpen={setIsPlacedUnplacedOpen}
						setIsPlacedAnchorEl={setIsPlacedAnchorEl}
						setRefreshCounter={setRefreshCounter}
						refreshCounter={refreshCounter}
						setIsFiltersOpen={setIsFiltersOpen}
						setIsLoading={setIsLoading}
						isScannable={isScannable}
						setIsAutoRefresh={setIsAutoRefresh}
						isAutoRefresh={isAutoRefresh}
					/>
				</div>
			)}
			{isMobile && (
				<MobileOutliersButton
					setIsLive={setIsLive}
					isPlacedUnplacedOpen={isPlacedUnplacedOpen}
					allBetsOpen={allBetsOpen}
					isPlacedAnchorEl={isPlacedAnchorEl}
					setAllBetsOpen={setAllBetsOpen}
					isFiltersOpen={isFiltersOpen}
					isLive={isLive}
					setIsPlacedUnplacedOpen={setIsPlacedUnplacedOpen}
					setIsPlacedAnchorEl={setIsPlacedAnchorEl}
					setRefreshCounter={setRefreshCounter}
					refreshCounter={refreshCounter}
					setIsFiltersOpen={setIsFiltersOpen}
					setIsLoading={setIsLoading}
					isScannable={isScannable}
					setIsAutoRefresh={setIsAutoRefresh}
					isAutoRefresh={isAutoRefresh}
					// Sorting props
					order={sortDirection}
					setOrder={setSortDirection}
					orderBy={sortColumn === 'max_discrepancy_pct' ? 'ev' : 'time'}
					setOrderBy={(newOrderBy) => {
						setSortColumn(newOrderBy === 'ev' ? 'max_discrepancy_pct' : 'time');
					}}
				/>
			)}
			{isFiltersOpen && (
				<div className="px-4 mb-6">
					<div className="w-full max-w-[95vw] mx-auto">
						{isMobile ? (
							<MobileOutliersFilters
								filters={filters}
								setFilters={setFilters}
								setIsFiltersOpen={setIsFiltersOpen}
								email={user?.email}
								isMobile={isMobile}
								queries={queries}
								setQueries={setQueries}
								user={userState}
								setUser={setUserState}
							/>
						) : (
							<FiltersContainerOutliers
								// defaultStake={globalStake}
								filters={filters}
								setFilters={setFilters}
								setIsFiltersOpen={setIsFiltersOpen}
								email={user?.email}
								isMobile={isMobile}
							/>
						)}
					</div>
				</div>
			)}

			{!isFree && !isApprentice && !isMobile && (
				<div className="px-4 md:px-4 xl:px-6 pt-8">
					<div className="w-full max-w-[95vw] mx-auto" style={{ 
						overflowX: 'auto', 
						overflowY: 'visible',
						borderRadius: '16px',
						background: 'linear-gradient(135deg, #17191d 0%, #1a1d23 100%)',
						padding: '0',
						margin: '0',
						position: 'relative',
						width: '100%',
						boxSizing: 'border-box',
						boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
						border: '1px solid rgba(255, 255, 255, 0.1)',
						backdropFilter: 'blur(10px)'
					}}>
					<Table
						id="outlier-table"
						sx={{
							'& .MuiTableCell-root': {
								fontFamily: 'Mulish, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
								fontSize: '0.875rem',
								lineHeight: 1.5,
							},
							backgroundColor: 'transparent',
							tableLayout: 'fixed',
							width: '100%',
						}}>
						<colgroup>
							<col style={{ width: '9%' }} />
							<col style={{ width: '10%' }} />
							<col style={{ width: '18%' }} />
							<col style={{ width: '18%' }} />
							<col style={{ width: '12%' }} />
							<col style={{ width: '10%' }} />
							<col style={{ width: '8%' }} />
							<col style={{ width: '5%' }} />
							<col style={{ width: '10%' }} />
						</colgroup>
						<TableHead
							sx={{
								'& .MuiTableRow-root:first-of-type .MuiTableCell-root:first-of-type': {
									borderTopLeftRadius: '16px',
								},
								'& .MuiTableRow-root:first-of-type .MuiTableCell-root:last-of-type': {
									borderTopRightRadius: '16px',
								},
								'& .MuiTableCell-root': {
									borderBottom: 'none',
									borderRight: 'none',
									borderLeft: 'none',
									background: 'transparent',
								}
							}}
							className="tableHead">
							<TableRow sx={{ 
								height: 80,
								'&:hover': {
									backgroundColor: 'rgba(255, 255, 255, 0.05)',
								}
							}}>
								<TableCell sx={{ width: '9%', minWidth: '60px', textAlign: 'left' }} className="tableHeadCell">
									LEAGUE
								</TableCell>
								<TableCell sx={{ width: '10%', minWidth: '90px', textAlign: 'left' }} className="tableHeadCell">
									MARKET
								</TableCell>
								<TableCell
									sx={{ width: '18%', minWidth: '180px', textAlign: 'left' }}
									onClick={() => {
										if (sortColumn === 'time') {
											setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
										} else {
											setSortColumn('time');
											setSortDirection('asc');
										}
									}}
									className="tableHeadCell cursor-pointer">
									<span className="flex items-center">
										EVENT
										{sortColumn === 'time' && (sortDirection === 'asc' ? ' ▲' : ' ▼')}
									</span>
								</TableCell>
								<TableCell colSpan={1} sx={{ width: '18%', minWidth: '180px', textAlign: 'left' }} className="tableHeadCell">
									BET
								</TableCell>
								<TableCell colSpan={1} sx={{ width: '12%', minWidth: '120px', textAlign: 'left' }} className="tableHeadCell">
									BOOK
								</TableCell>
								<TableCell
									sx={{ width: '11%', minWidth: '110px', textAlign: 'left' }}
									onClick={() => {
										if (sortColumn === 'max_discrepancy_pct') {
											setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
										} else {
											setSortColumn('max_discrepancy_pct');
											setSortDirection('desc');
										}
									}}
									className="tableHeadCell cursor-pointer">
									<span className="flex items-center">
										Discrepancy%
										{sortColumn === 'max_discrepancy_pct' && (sortDirection === 'asc' ? ' ▲' : ' ▼')}
									</span>
								</TableCell>
								<TableCell sx={{ width: '8%', minWidth: '80px', textAlign: 'left' }} className="tableHeadCell">
									ODDS
								</TableCell>
								<TableCell sx={{ width: '10%', minWidth: '100px', textAlign: 'left' }} className="tableHeadCell">
									AVG ODDS
								</TableCell>
								<TableCell sx={{ width: '10%', minWidth: '120px', textAlign: 'left' }} className="tableHeadCell">
									PLACED?
								</TableCell>
							</TableRow>
						</TableHead>
						{!isLoading && (
							<TableBody className={`tableBody ${isLoading ? 'loading' : ''}`}>
								{Array.isArray(visibleRows) &&
									visibleRows.map((row, i) => {
										const splitoutcomeid = row.outcome_id_normalized_no_book.split(':');
										let isOver = true;

										if (!row.over_discrepancy_pct || row.under_discrepancy_pct > row.over_discrepancy_pct) {
											isOver = false;
										}
										// const splitoutcomeidbothbooks = row.outcome_id_normalized.split(':');

										// if (i === 0) {
										// 	console.log(row);
										// }
										let condition = row.game;
										let betName;
										if (isOver) {
											betName = `${splitoutcomeid[2]} over ${splitoutcomeid[3]} ${splitoutcomeid[1]}`;
										} else {
											if (splitoutcomeid[3] === '') {
												betName = `${splitoutcomeid[2]}`;
											} else {
												betName = `${splitoutcomeid[2]} under ${splitoutcomeid[3]} ${splitoutcomeid[1]}`;
											}
										}
										if (splitoutcomeid[1] === 'Moneyline') {
											betName = `${splitoutcomeid[2]}`;
										}

										if (splitoutcomeid[1] === 'Round Betting' || splitoutcomeid[2] === 'Draw') {
											condition = false;
										}

										if (condition) {
											return (
												<>
													<TableRow
														style={{ 
															transition: 'all 0.3s ease-in-out',
															cursor: 'pointer',
														}}
														onClick={async () => {
															if (selectedRow === row.outcome_id_normalized) {
																setSelectedRow();
																setSelectedSport();
																setSelectedRowIndex(null);
															} else {
																if (row.outcome_id_normalized !== '') {
																	setSelectedRow(row.outcome_id_normalized);
																	setSelectedSport(row.sport);
																	setSelectedRowIndex(i); // 👈 Save the index
										const relatedOdds = await getRelatedOdds(
											row.outcome_id_normalized_no_book,
											row.sport,
											{ market: row.market, points: row.points, home_team: row.game?.home_team_display || row.home_team }
										);
																	setRelatedOdds(relatedOdds);
																} else {
																	// setIsUpgradeModalOpen(true);
																}
															}
														}}
														className={`${selectedRow === row.outcome_id_normalized ? 'outlier-row-selected' : (i % 2 !== 0 ? 'outlier-row2' : 'outlier-row1')} ${selectedRow === row.outcome_id_normalized && 'selectedrow'} outlier-row`}
														key={i}>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '9%', minWidth: '60px' }}>
															{row.league}
														</TableCell>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '10%', minWidth: '90px' }}>
															{splitoutcomeid[1]}
														</TableCell>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '18%', minWidth: '180px' }}>
															<Typography style={{ color: '#b1b6c3' }} variant="body2">
																{new Date(row.game.start_date).toLocaleString()}
															</Typography>
															<Typography style={{ color: '#f0f2f6' }} variant="caption">
																{row.game.away_team_display} @ {row.game.home_team_display}
															</Typography>
														</TableCell>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '18%', minWidth: '180px' }}>
															<Box>
																<Typography style={{ color: '#f0f2f6' }}>{betName}</Typography>
															</Box>
														</TableCell>

														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '12%', minWidth: '120px' }}>
															<div className="flex flex-row" style={{ width: '100%', overflow: 'hidden' }}>
																<Box>
																	<Typography sx={{ height: '45px' }}>
																		<LogoGenerator sportsbook={row.sportsbook} />{' '}
																	</Typography>
																</Box>
																{row.linkOver && <BetLinkButton link={row.linkOver} />}
															</div>
														</TableCell>

														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '11%', minWidth: '110px' }}>
															<EVPercent ev={row.max_discrepancy_pct} />
														</TableCell>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', fontWeight: 'bold', width: '8%', minWidth: '80px' }}>
															{isOver
																? addPlusSign(convertDecimalToAmerican(row.bet_price_over).toFixed(0))
																: addPlusSign(convertDecimalToAmerican(row.bet_price_under).toFixed(0))}
														</TableCell>
														<TableCell style={{ color: '#f0f2f6', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', width: '10%', minWidth: '100px' }}>
															<div style={{ textAlign: 'center', marginBottom: 12, fontWeight: 'bold' }}>
																{isOver ? addPlusSign(convertDecimalToAmerican(row.avg_over).toFixed(0)) : addPlusSign(convertDecimalToAmerican(row.avg_under).toFixed(0))}
															</div>
															<div style={{ width: 160, overflow: 'hidden', whiteSpace: 'nowrap' }}>
																{isOver ? (
																	<SportsbookLogos sportsbooks_used_for_avg={row.sportsbooks_used_for_avg_over} />
																) : (
																	<SportsbookLogos sportsbooks_used_for_avg={row.sportsbooks_used_for_avg_under} />
																)}
															</div>
														</TableCell>
														<TableCell
															style={{
																backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '',
																width: '10%',
																minWidth: '120px',
																overflow: 'visible',
															}}>
															<div
																data-popover-trigger
																style={{ width: '100%', backgroundColor: selectedRow === row.outcome_id_normalized ? '#363844' : '', overflow: 'visible', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 1 }}
																onMouseEnter={(e) => {
																	// Clear any pending timeout
																	if (hoverTimeoutRef.current) {
																		clearTimeout(hoverTimeoutRef.current);
																		hoverTimeoutRef.current = null;
																	}
																	// Show popover when hovering over checkbox or amount display (if bet is placed)
																	if (placedBets?.some((placedBet) => placedBet.id === row.outcome_id_normalized)) {
																		const checkbox = e.currentTarget.querySelector('.MuiCheckbox-root');
																		if (checkbox) {
																			setAmountPopoverAnchor(checkbox);
																			setAmountPopoverRowId(row.outcome_id_normalized);
																		}
																	}
																}}
																onMouseLeave={(e) => {
																	// Check if mouse is moving to popover
																	const relatedTarget = e.relatedTarget;
																	const isMovingToPopover = relatedTarget instanceof Node && (
																		popoverRef.current?.contains(relatedTarget) ||
																		relatedTarget.closest('[role="presentation"]')?.querySelector('[class*="MuiPopover"]')
																	);
																	
																	if (!isMovingToPopover) {
																		// Delay closing to allow moving to popover
																		hoverTimeoutRef.current = setTimeout(() => {
																			setAmountPopoverAnchor(null);
																			setAmountPopoverRowId(null);
																			hoverTimeoutRef.current = null;
																		}, 150);
																	}
																}}
																onClick={(e) => {
																	// If clicking on the checkbox area (not the popover), allow the click to pass through
																	const isCheckbox = e.target.closest('.MuiCheckbox-root');
																	if (isCheckbox) {
																		// Close popover when clicking checkbox area
																		if (hoverTimeoutRef.current) {
																			clearTimeout(hoverTimeoutRef.current);
																			hoverTimeoutRef.current = null;
																		}
																		setAmountPopoverAnchor(null);
																		setAmountPopoverRowId(null);
																	}
																}}
															>
																<Tooltip title={''}>
																	<Checkbox
																		onClick={(e) => {
																			e.stopPropagation();
																			// Close popover when clicking checkbox
																			if (hoverTimeoutRef.current) {
																				clearTimeout(hoverTimeoutRef.current);
																				hoverTimeoutRef.current = null;
																			}
																			setAmountPopoverAnchor(null);
																			setAmountPopoverRowId(null);
																		}}
																		sx={{
																			color: selectedRow === row.outcome_id_normalized ? '#7a7e96' : '#363844', // Default border color when unchecked
																			'&.Mui-checked': {
																				color: '#28792a', // Border and check color when checked
																			},
																			'&:hover': {
																				color: '#5dcc60', // Border color on hover
																			},
																			position: 'relative',
																			zIndex: 10, // Ensure checkbox is above popover
																		}}
																		onChange={async (e) => {
																			if (row.outcome_id_normalized !== '') {
																				if (e.target.checked) {
																					await setBetPlaced(row.outcome_id_normalized, user.email);
																					setPlacedBets([...placedBets, { id: row.outcome_id_normalized, time: new Date() }]);
																				} else {
																					const copy = JSON.parse(JSON.stringify(placedBets));
																					const newCopy = removeObjectWithProperty(copy, 'id', row.outcome_id_normalized);
																					setPlacedBets(newCopy);
																					await removeBetPlaced(row.outcome_id_normalized, user.email);
																				}
																			}
																		}}
																		checked={placedBets?.some((placedBet) => placedBet.id === row.outcome_id_normalized)}
																	/>
																</Tooltip>
																{placedBets?.some((placedBet) => placedBet.id === row.outcome_id_normalized) && (() => {
																	const percentOfTotalBankroll = isNaN(placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value / bankroll)
																		? 0
																		: placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value / bankroll;
																	return (
																		<div 
																			style={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '4px', width: '100%' }}
																			onMouseEnter={(e) => {
																				// Clear any pending timeout when hovering over amount display
																				if (hoverTimeoutRef.current) {
																					clearTimeout(hoverTimeoutRef.current);
																					hoverTimeoutRef.current = null;
																				}
																				// Ensure popover is open when hovering over amount display
																				if (amountPopoverRowId !== row.outcome_id_normalized) {
																					const checkbox = e.currentTarget.closest('[data-popover-trigger]')?.querySelector('.MuiCheckbox-root');
																					if (checkbox) {
																						setAmountPopoverAnchor(checkbox);
																						setAmountPopoverRowId(row.outcome_id_normalized);
																					}
																				}
																			}}
																		>
																			<div style={{ fontSize: '13px', fontWeight: 500 }}>
																				${placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value || '0.00'}
																			</div>
																			<div style={{ fontSize: '9px', color: '#9ca3af', marginTop: '2px' }}>
																				{(percentOfTotalBankroll * 100).toFixed(2)}%
																			</div>
																		</div>
																	);
																})()}
																<Popover
																	open={amountPopoverAnchor !== null && amountPopoverRowId === row.outcome_id_normalized}
																	anchorEl={amountPopoverAnchor}
																	onClose={(e, reason) => {
																		// Clear any pending timeout
																		if (hoverTimeoutRef.current) {
																			clearTimeout(hoverTimeoutRef.current);
																			hoverTimeoutRef.current = null;
																		}
																		// Close on backdrop click or escape key
																		setAmountPopoverAnchor(null);
																		setAmountPopoverRowId(null);
																	}}
																	anchorOrigin={{
																		vertical: 'bottom',
																		horizontal: 'left',
																	}}
																	transformOrigin={{
																		vertical: 'top',
																		horizontal: 'left',
																	}}
																	disableRestoreFocus
																	onClick={(e) => {
																		// Allow clicks inside the popover
																		e.stopPropagation();
																	}}
																	slotProps={{
																		root: {
																			onClick: (e) => {
																				// Don't close if clicking inside the popover paper
																				if (popoverRef.current && popoverRef.current.contains(e.target)) {
																					return;
																				}
																				// Close if clicking outside
																				if (hoverTimeoutRef.current) {
																					clearTimeout(hoverTimeoutRef.current);
																					hoverTimeoutRef.current = null;
																				}
																				setAmountPopoverAnchor(null);
																				setAmountPopoverRowId(null);
																			},
																			style: {
																				pointerEvents: 'none', // Allow clicks to pass through to checkbox
																			}
																		}
																	}}
																	PaperProps={{
																		ref: popoverRef,
																		onMouseEnter: () => {
																			// Cancel any pending close timeout when hovering over popover
																			if (hoverTimeoutRef.current) {
																				clearTimeout(hoverTimeoutRef.current);
																				hoverTimeoutRef.current = null;
																			}
																		},
																		onMouseLeave: (e) => {
																			// Check if mouse is moving back to trigger area
																			const relatedTarget = e.relatedTarget;
																			const isMovingToTrigger = relatedTarget instanceof Node && (
																				relatedTarget.closest('[data-popover-trigger]') ||
																				relatedTarget.closest('.MuiCheckbox-root')
																			);
																			
																			if (!isMovingToTrigger) {
																				// Close when leaving popover and not moving to trigger
																				if (hoverTimeoutRef.current) {
																					clearTimeout(hoverTimeoutRef.current);
																					hoverTimeoutRef.current = null;
																				}
																				setAmountPopoverAnchor(null);
																				setAmountPopoverRowId(null);
																			}
																		},
																		onClick: (e) => {
																			// Stop propagation so clicks inside popover don't close it
																			e.stopPropagation();
																		},
																		style: {
																			backgroundColor: '#1a1d23',
																			padding: '12px',
																			borderRadius: '8px',
																			border: '1px solid rgba(255, 255, 255, 0.1)',
																			pointerEvents: 'auto', // Popover content should be clickable
																		}
																	}}
																>
																	<div 
																		onMouseEnter={() => {
																			// Cancel the timeout when hovering over popover content
																			if (hoverTimeoutRef.current) {
																				clearTimeout(hoverTimeoutRef.current);
																				hoverTimeoutRef.current = null;
																			}
																		}}
																		style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '150px' }}
																	>
																		<div style={{ fontSize: '12px', color: '#b1b6c3', marginBottom: '4px' }}>Amount ($)</div>
																		<input
																			onClick={(e) => {
																				e.stopPropagation();
																			}}
																			type="number"
																			onKeyDown={(e) => {
																				if (e.key === 'Enter') {
																					// Close popover when Enter is pressed
																					if (hoverTimeoutRef.current) {
																						clearTimeout(hoverTimeoutRef.current);
																						hoverTimeoutRef.current = null;
																					}
																					setAmountPopoverAnchor(null);
																					setAmountPopoverRowId(null);
																					// Remove focus from input
																					e.target.blur();
																				}
																			}}
																			onChange={async (e) => {
																				const copy = JSON.parse(JSON.stringify(placedBets));
																				for (const placedbet of copy) {
																					if (placedbet.id === row.outcome_id_normalized) {
																						placedbet.value = e.target.value;
																					}
																				}
																				setPlacedBets(copy);
																				await setBetPlaced(row.outcome_id_normalized, user.email, e.target.value);
																			}}
																			value={placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value || ''}
																			style={{
																				width: '100%',
																				padding: '8px',
																				border: '1px solid rgba(255, 255, 255, 0.2)',
																				outline: 'none',
																				backgroundColor: '#363844',
																				color: '#b1b6c3',
																				borderRadius: '6px',
																				fontSize: '14px',
																				boxSizing: 'border-box',
																			}}
																			autoFocus
																		/>
																		{(() => {
																			const percentOfTotalBankroll = isNaN(placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value / bankroll)
																				? 0
																				: placedBets?.find((placedbet) => placedbet.id === row.outcome_id_normalized)?.value / bankroll;
																			return (
																				<div style={{ fontSize: '10px', color: '#9ca3af', marginTop: '4px' }}>
																					{(percentOfTotalBankroll * 100).toFixed(2)}% of bankroll
																				</div>
																			);
																		})()}
																	</div>
																</Popover>
															</div>
														</TableCell>
													</TableRow>
													{selectedRow === row.outcome_id_normalized && relatedOdds && (
														<TableRow className="dropdown evtable-dropdown">
															<TableCell style={{ padding: 0 }} colSpan={9}>
																<RelatedOddsDropdown
																	isArbitrage={true}
																	relatedOdds={relatedOdds}
																	isOver={row.ev_over > row.ev_under}
																	sportsbooksToHighlight={[splitoutcomeid[4], splitoutcomeid[5]]}
																	sportsbook_dumb={row.sportsbook_dumb}
																	outcome_id_normalized={selectedRow}
																	sharpBook={`${splitoutcomeid[4]},${splitoutcomeid[5]}`}
																	sharpFilter={''}
																	fairValue={null}
																	selectedRow={selectedRow}
																	selectedSport={selectedSport}
																	overSide={'bet_price_over'}
																	underSide={'bet_price_under'}
																	tutorial={false}
																	isLive={isLive}
																	sharpPriceOver={null}
																	sharpPriceUnder={null}
																/>
															</TableCell>
														</TableRow>
													)}
												</>
											);
										}
									})}
							</TableBody>
						)}
					</Table>
					</div>
				</div>
			)}

			{!isLoading && !isFree && !isApprentice && isMobile && (
				<div>
					{/* Add a larger space before the first card */}
					<Box sx={{ height: 32 }} />
					{Array.isArray(visibleRows) &&
						visibleRows.map((row, i) => {
							const splitoutcomeid = row.outcome_id_normalized_no_book.split(':');
							let isOver = true;

							if (!row.over_discrepancy_pct || row.under_discrepancy_pct > row.over_discrepancy_pct) {
								isOver = false;
							}
							let condition = row.game;
							let betName;
							if (isOver) {
								betName = `${splitoutcomeid[2]} over ${splitoutcomeid[3]} ${splitoutcomeid[1]}`;
							} else {
								if (splitoutcomeid[3] === '') {
									betName = `${splitoutcomeid[2]}`;
								} else {
									betName = `${splitoutcomeid[2]} under ${splitoutcomeid[3]} ${splitoutcomeid[1]}`;
								}
							}
							if (splitoutcomeid[1] === 'Moneyline') {
								betName = `${splitoutcomeid[2]}`;
							}

							if (splitoutcomeid[1] === 'Round Betting' || splitoutcomeid[2] === 'Draw') {
								condition = false;
							}

							if (condition) {
								// Construct play title
								let playTitle = '';
								if (splitoutcomeid[1] === 'Moneyline') {
									playTitle = `${splitoutcomeid[2]} Moneyline`;
								} else if (splitoutcomeid[3] && splitoutcomeid[1]) {
									playTitle = `${splitoutcomeid[2]} ${splitoutcomeid[3]} ${splitoutcomeid[1]}`;
								} else {
									playTitle = betName;
								}
								return (
									<Card
										key={i}
										sx={{
											background: 'linear-gradient(180deg, #23252B 0%, #181A1F 100%)',
											color: 'white',
											mb: 3,
											mx: 'auto',
											borderRadius: 4,
											border: '2.5px solid rgba(122,209,255,0.18)',
											boxShadow: '0 6px 32px 0 rgba(0,0,0,0.25), 0 0 0 3px rgba(122,209,255,0.10)',
											width: '97%',
											maxWidth: 430,
											position: 'relative',
											overflow: 'hidden',
										}}>
										<CardContent sx={{ p: 2 }}>
											{/* Play Title */}
											<Box sx={{ mb: 1, display: 'flex', justifyContent: 'center' }}>
												<Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: 19, color: '#7ad1ff', textAlign: 'center', letterSpacing: 0.1, lineHeight: 1.2 }}>
													{playTitle}
												</Typography>
											</Box>
											{/* Event Section */}
											<Box
												sx={{
													background: 'rgba(35,37,43,0.85)',
													borderRadius: 2,
													p: 1.5,
													mb: 2,
													border: '1px solid rgba(122,209,255,0.10)',
													boxShadow: '0 1px 8px 0 rgba(122,209,255,0.04)',
												}}>
												<Typography variant="caption" sx={{ color: '#b1b6c1', fontWeight: 500 }}>
													{row.league}
												</Typography>
												<Typography variant="h6" sx={{ fontWeight: 700, color: 'white', mt: 0.5 }}>
													{row.game.away_team_display} <span style={{ color: '#b1b6c1', fontWeight: 400 }}>@</span> {row.game.home_team_display}
												</Typography>
												<Typography variant="caption" sx={{ color: '#b1b6c1', fontWeight: 400 }}>
													{new Date(row.game.start_date).toLocaleString()}
												</Typography>
											</Box>

											{/* Bet Section */}
											<Box
												sx={{
													background: 'rgba(32,35,42,0.80)',
													border: '1px solid rgba(122,209,255,0.08)',
													borderRadius: 2,
													p: 1.5,
													mb: 2,
													boxShadow: '0 1px 8px 0 rgba(122,209,255,0.03)',
												}}>
												<Typography variant="subtitle2" sx={{ fontWeight: 600, color: isOver ? '#7ad1ff' : '#ffb47a', mb: 0.5 }}>
													{betName}
												</Typography>
												<TableBody>
													<TableRow>
														<TableCell sx={{ border: 'none', paddingLeft: 0 }}>
															<LogoGenerator sportsbook={row.sportsbook} />
														</TableCell>
														<TableCell sx={{ border: 'none' }}>
															<Typography sx={{ alignContent: 'center', color: 'white', fontWeight: 'bold' }} ml={1}>
																{addPlusSign(convertDecimalToAmerican(Math.round(row.bet_price_over)))}
															</Typography>
														</TableCell>
														<TableCell sx={{ color: 'white', border: 'none' }}>{row.linkOver && <BetLinkButton link={row.linkOver} />}</TableCell>
													</TableRow>
													<TableRow>
														<TableCell sx={{ border: 'none', paddingLeft: 0 }}>
															{isOver ? (
																<SportsbookLogos sportsbooks_used_for_avg={row.sportsbooks_used_for_avg_over} />
															) : (
																<SportsbookLogos sportsbooks_used_for_avg={row.sportsbooks_used_for_avg_under} />
															)}
														</TableCell>
														<TableCell sx={{ border: 'none' }}>
															<Typography sx={{ alignContent: 'center', color: 'white', fontWeight: 'bold' }} ml={1}>
																<div style={{ textAlign: 'center', marginBottom: 12 }}>
																	{isOver ? addPlusSign(convertDecimalToAmerican(row.avg_over).toFixed(0)) : addPlusSign(convertDecimalToAmerican(row.avg_under).toFixed(0))}
																</div>
																<p style={{ fontSize: 8 }}>(market avg)</p>
															</Typography>
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell sx={{ color: 'white', border: 'none', paddingLeft: 0 }}>Discrepancy:</TableCell>
														<TableCell sx={{ border: 'none' }}>
															<EVPercent ev={row.max_discrepancy_pct} />
														</TableCell>
													</TableRow>
												</TableBody>
											</Box>

											<Button
												onClick={async () => {
													if (selectedRow === row.outcome_id_normalized) {
														setSelectedRow();
														setSelectedSport();
														setSelectedRowIndex(null);
													} else {
														if (row !== '') {
															setSelectedRow(row.outcome_id_normalized);
															setSelectedSport(row.sport);
															setSelectedRowIndex(i); // 👈 Save the index
											const relatedOdds = await getRelatedOdds(
												row.outcome_id_normalized_no_book,
												row.sport,
												{ market: row.market, points: row.points, home_team: row.game?.home_team_display || row.home_team }
											);
															setRelatedOdds(relatedOdds);
														} else {
															setIsUpgradeModalOpen(true);
														}
													}
												}}
												className="bg-gray-700 w-full mt-4 text-white py-2 rounded-lg">
												{selectedRow === row.outcome_id_normalized ? 'Hide details' : 'View details'}
											</Button>
										</CardContent>
										{selectedRow === row.outcome_id_normalized && relatedOdds && (
											<RelatedOddsDropdown
												isArbitrage={true}
												relatedOdds={relatedOdds}
												isOver={row.ev_over > row.ev_under}
												sportsbooksToHighlight={[splitoutcomeid[4], splitoutcomeid[5]]}
												sportsbook_dumb={row.sportsbook_dumb}
												outcome_id_normalized={selectedRow}
												sharpBook={`${splitoutcomeid[4]},${splitoutcomeid[5]}`}
												sharpFilter={''}
												fairValue={null}
												selectedRow={selectedRow}
												selectedSport={selectedSport}
												overSide={'bet_price_over'}
												underSide={'bet_price_under'}
												tutorial={false}
												isLive={isLive}
												sharpPriceOver={null}
												sharpPriceUnder={null}
												isMobile={true}
											/>
										)}
									</Card>
								);
							} else return <></>;
						})}
				</div>
			)}

			{isLoading && (
				<div style={{ justifySelf: 'center' }}>
					<img style={{ marginTop: '40px' }} width={300} src={wwlogo_gif} alt="loading icon" />
				</div>
			)}
			<UpgradeModal message={'Outlier plays page not available for your plan'} isOpen={isUpgradeModalOpen} setIsOpen={() => setIsUpgradeModalOpen(false)} />
		</div>
	);
};
